module.exports = __webpack_public_path__ + "prod/20260821164531/img/url-app.d88da72d.png";